export default __webpack_public_path__ + "static/media/Wall_Conveyor_x3_Grey.64.c47e8630.png";